import * as type from '../../../actions/index.types'

const initialState = {
    // List
    receiptsData: [],
    receiptsPagination: null,
    loading: false,
    error: null,

    // Details
    receiptDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Receipts by Flat
    receiptsByFlat: [],
    receiptsByFlatLoading: false,
    receiptsByFlatError: null,

    // Create
    createLoading: false,
    createError: null,

    // Update
    updateLoading: false,
    updateError: null,

    // Delete (Cancel)
    deleteLoading: false,
    deleteError: null,

    // Clear
    clearLoading: false,
    clearError: null,

    // Bounce
    bounceLoading: false,
    bounceError: null,

    // Outstanding Documents
    outstandingInvoices: [],
    outstandingDebitNotes: [],
    outstandingLoading: false,
    outstandingError: null,

    // Allocation Component Preview
    allocationComponents: [],
    componentsLoading: false,
    componentsError: null,

    // Update Allocations
    updateAllocationsLoading: false,
    updateAllocationsError: null,

    // Bulk Upload
    bulkUploadLoading: false,
    bulkUploadResult: null,
    bulkUploadError: null,

    // Bulk Get Details
    bulkDetailsLoading: false,
    bulkDetailsData: [],
    bulkDetailsError: null,

    // Bulk Cancel
    bulkCancelLoading: false,
    bulkCancelResult: null,
    bulkCancelError: null,

    // Bulk Bounce
    bulkBounceLoading: false,
    bulkBounceResult: null,
    bulkBounceError: null,

    // Bulk Clear
    bulkClearLoading: false,
    bulkClearResult: null,
    bulkClearError: null,
}

export function ReceiptReducer(state = initialState, action) {
    switch (action.type) {
        // Get Receipts
        case type.GET_RECEIPTS:
            return { ...state, loading: true, error: null }
        case type.GET_RECEIPTS_SUCCESS:
            return {
                ...state,
                loading: false,
                receiptsData: action.payload?.data || [],
                receiptsPagination: action.payload?.meta?.pagination || null,
                error: null
            }
        case type.GET_RECEIPTS_FAILURE:
            return { ...state, loading: false, error: action?.message || 'Failed to fetch receipts' }

        // Get Receipt Details
        case type.GET_RECEIPT_DETAILS:
            return { ...state, detailsLoading: true, detailsError: null }
        case type.GET_RECEIPT_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                receiptDetails: action.payload?.data || null,
                detailsError: null
            }
        case type.GET_RECEIPT_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, detailsError: action?.message || 'Failed to fetch receipt details' }

        // Get Receipts by Flat
        case type.GET_RECEIPTS_BY_FLAT:
            return { ...state, receiptsByFlatLoading: true, receiptsByFlatError: null }
        case type.GET_RECEIPTS_BY_FLAT_SUCCESS:
            return {
                ...state,
                receiptsByFlatLoading: false,
                receiptsByFlat: action.payload?.data || [],
                receiptsByFlatError: null
            }
        case type.GET_RECEIPTS_BY_FLAT_FAILURE:
            return { ...state, receiptsByFlatLoading: false, receiptsByFlatError: action?.message || 'Failed to fetch receipts by flat' }

        // Create
        case type.CREATE_RECEIPT:
            return { ...state, createLoading: true, createError: null }
        case type.CREATE_RECEIPT_SUCCESS:
            return { ...state, createLoading: false, createError: null }
        case type.CREATE_RECEIPT_FAILURE:
            return { ...state, createLoading: false, createError: action?.message || 'Failed to create receipt' }

        // Update
        case type.UPDATE_RECEIPT:
            return { ...state, updateLoading: true, updateError: null }
        case type.UPDATE_RECEIPT_SUCCESS:
            return { ...state, updateLoading: false, updateError: null }
        case type.UPDATE_RECEIPT_FAILURE:
            return { ...state, updateLoading: false, updateError: action?.message || 'Failed to update receipt' }

        // Delete (Cancel)
        case type.DELETE_RECEIPT:
            return { ...state, deleteLoading: true, deleteError: null }
        case type.DELETE_RECEIPT_SUCCESS:
            return { ...state, deleteLoading: false, deleteError: null }
        case type.DELETE_RECEIPT_FAILURE:
            return { ...state, deleteLoading: false, deleteError: action?.message || 'Failed to cancel receipt' }

        // Clear
        case type.CLEAR_RECEIPT:
            return { ...state, clearLoading: true, clearError: null }
        case type.CLEAR_RECEIPT_SUCCESS:
            return { ...state, clearLoading: false, clearError: null }
        case type.CLEAR_RECEIPT_FAILURE:
            return { ...state, clearLoading: false, clearError: action?.message || 'Failed to clear receipt' }

        // Bounce
        case type.BOUNCE_RECEIPT:
            return { ...state, bounceLoading: true, bounceError: null }
        case type.BOUNCE_RECEIPT_SUCCESS:
            return { ...state, bounceLoading: false, bounceError: null }
        case type.BOUNCE_RECEIPT_FAILURE:
            return { ...state, bounceLoading: false, bounceError: action?.message || 'Failed to bounce receipt' }

        // Outstanding Documents
        case type.GET_OUTSTANDING_DOCUMENTS:
            return { ...state, outstandingLoading: true, outstandingError: null }
        case type.GET_OUTSTANDING_DOCUMENTS_SUCCESS:
            return {
                ...state,
                outstandingLoading: false,
                outstandingInvoices: action.payload?.data?.invoices || [],
                outstandingDebitNotes: action.payload?.data?.debitNotes || [],
                outstandingError: null
            }
        case type.GET_OUTSTANDING_DOCUMENTS_FAILURE:
            return { ...state, outstandingLoading: false, outstandingError: action?.message || 'Failed to fetch outstanding documents' }

        // Allocation Component Preview
        case type.CALCULATE_ALLOCATION_COMPONENTS:
            return { ...state, componentsLoading: true, componentsError: null }
        case type.CALCULATE_ALLOCATION_COMPONENTS_SUCCESS:
            return {
                ...state,
                componentsLoading: false,
                allocationComponents: action.payload?.data || [],
                componentsError: null
            }
        case type.CALCULATE_ALLOCATION_COMPONENTS_FAILURE:
            return { ...state, componentsLoading: false, componentsError: action?.message || 'Failed to calculate components' }

        // Update Receipt Allocations
        case type.UPDATE_RECEIPT_ALLOCATIONS:
            return { ...state, updateAllocationsLoading: true, updateAllocationsError: null }
        case type.UPDATE_RECEIPT_ALLOCATIONS_SUCCESS:
            return { ...state, updateAllocationsLoading: false, updateAllocationsError: null }
        case type.UPDATE_RECEIPT_ALLOCATIONS_FAILURE:
            return { ...state, updateAllocationsLoading: false, updateAllocationsError: action?.message || 'Failed to update allocations' }

        // Bulk Upload
        case type.BULK_UPLOAD_RECEIPTS:
            return { ...state, bulkUploadLoading: true, bulkUploadResult: null, bulkUploadError: null }
        case type.BULK_UPLOAD_RECEIPTS_SUCCESS:
            return { ...state, bulkUploadLoading: false, bulkUploadResult: action.payload, bulkUploadError: null }
        case type.BULK_UPLOAD_RECEIPTS_FAILURE:
            return { ...state, bulkUploadLoading: false, bulkUploadError: action?.message || 'Bulk upload failed' }

        // Clear Bulk Upload State
        case type.CLEAR_RECEIPT_BULK_UPLOAD_STATE:
            return { ...state, bulkUploadLoading: false, bulkUploadResult: null, bulkUploadError: null }

        // Bulk Get Details
        case type.BULK_GET_RECEIPT_DETAILS:
            return { ...state, bulkDetailsLoading: true, bulkDetailsError: null }
        case type.BULK_GET_RECEIPT_DETAILS_SUCCESS:
            return { ...state, bulkDetailsLoading: false, bulkDetailsData: action.payload?.data || [], bulkDetailsError: null }
        case type.BULK_GET_RECEIPT_DETAILS_FAILURE:
            return { ...state, bulkDetailsLoading: false, bulkDetailsError: action?.message || 'Failed to fetch bulk receipt details' }

        // Bulk Cancel
        case type.BULK_CANCEL_RECEIPTS:
            return { ...state, bulkCancelLoading: true, bulkCancelResult: null, bulkCancelError: null }
        case type.BULK_CANCEL_RECEIPTS_SUCCESS:
            return { ...state, bulkCancelLoading: false, bulkCancelResult: action.payload, bulkCancelError: null }
        case type.BULK_CANCEL_RECEIPTS_FAILURE:
            return { ...state, bulkCancelLoading: false, bulkCancelError: action?.message || 'Bulk cancel failed' }

        // Bulk Bounce
        case type.BULK_BOUNCE_RECEIPTS:
            return { ...state, bulkBounceLoading: true, bulkBounceResult: null, bulkBounceError: null }
        case type.BULK_BOUNCE_RECEIPTS_SUCCESS:
            return { ...state, bulkBounceLoading: false, bulkBounceResult: action.payload, bulkBounceError: null }
        case type.BULK_BOUNCE_RECEIPTS_FAILURE:
            return { ...state, bulkBounceLoading: false, bulkBounceError: action?.message || 'Bulk bounce failed' }

        // Bulk Clear
        case type.BULK_CLEAR_RECEIPTS:
            return { ...state, bulkClearLoading: true, bulkClearResult: null, bulkClearError: null }
        case type.BULK_CLEAR_RECEIPTS_SUCCESS:
            return { ...state, bulkClearLoading: false, bulkClearResult: action.payload, bulkClearError: null }
        case type.BULK_CLEAR_RECEIPTS_FAILURE:
            return { ...state, bulkClearLoading: false, bulkClearError: action?.message || 'Bulk clear failed' }

        // Clear State
        case type.CLEAR_RECEIPT_STATE:
            return initialState

        default:
            return state
    }
}
